import { Box } from "@mui/material";
import logodark from "../../assets/images/logo-dark.webp";
import logolight from "../../assets/images/logo-light.webp";
import logotextdark from "../../assets/images/logo-text-dark.webp";
import logotextlight from "../../assets/images/logo-text-light.webp";

type LogoProps = {
  imgLight: boolean;
  onClick: () => void;
};
const Logo = ({ imgLight, onClick }: LogoProps) => {
  return (
    <>
      <Box sx={{ whiteSpace: "nowrap", display: { xs: "block", md: "none" } }}>
        {/* visible only in smaller than md */}
        <img
          aria-hidden="true"
          src={logodark}
          alt="logo"
          className="logo"
          height="22"
          loading="lazy"
          onClick={onClick}
        />
        <img
          aria-hidden="true"
          src={logotextdark}
          alt="logo"
          className="logo"
          height="22"
          loading="lazy"
          onClick={onClick}
        />
      </Box>
      <Box sx={{ whiteSpace: "nowrap", display: { xs: "none", md: "block" } }}>
        {/* visible only in wider than md */}
        {imgLight === true ? (
          <>
            <img
              aria-hidden="true"
              src={logolight}
              alt="logo"
              className="logo"
              height="40"
              loading="lazy"
              onClick={onClick}
            />
            <img
              aria-hidden="true"
              src={logotextlight}
              alt="logo-text"
              className="logo"
              height="40"
              loading="lazy"
              onClick={onClick}
            />
          </>
        ) : (
          <>
            <img
              aria-hidden="true"
              src={logodark}
              alt="logo"
              className="logo"
              height="40"
              loading="lazy"
              onClick={onClick}
            />
            <img
              aria-hidden="true"
              src={logotextdark}
              alt="logo"
              className="logo"
              height="40"
              loading="lazy"
              onClick={onClick}
            />
          </>
        )}
      </Box>
    </>
  );
};

export default Logo;
